/**
 * Feature flags the Help Center's content follows. Read in the browser
 * through Vite (import.meta.env, replaced at build time) and in the Node
 * pre-renderer through process.env, so the static pages search engines read
 * and the live page always show the same articles.
 */
function readViteFlag() {
  try {
    // Static member access: Vite replaces it with a literal at build time.
    return import.meta.env.VITE_FAYE_INSURANCE_ENABLED;
  } catch {
    return undefined;
  }
}

function readNodeFlag() {
  try {
    // eslint-disable-next-line no-undef
    return typeof process !== 'undefined' ? process.env?.VITE_FAYE_INSURANCE_ENABLED : undefined;
  } catch {
    return undefined;
  }
}

const faye = String(readViteFlag() ?? readNodeFlag() ?? '') === 'true';

export const HELP_FLAGS = Object.freeze({ faye });

/** Whether content gated on `flag` (or not gated at all) is live. */
export function flagEnabled(flag, flags = HELP_FLAGS) {
  if (!flag) return true;
  return flags[flag] === true;
}
